import React, { useState } from "react";
import data from "./data";
import Text from "../../Text";

export default (props) => {
  const [selectedState, setSelectedState] = useState({});

  function onChange(e) {
    setSelectedState(data.filter((st) => e.target.value === st.id)[0]);
    if (props.onChange) {
      const state = data.filter((st) => e.target.value === st.id)[0];
      props.onChange(state.id, state.uf_code);
    }
  }
  return (
    <div className="form-group">
      <div className="form-label">
        <Text color="primary">Estado</Text>
      </div>
      <select
        id="state-location-select-state"
        className={`form-control ${props.className}`}
        value={selectedState.id}
        disabled={props.disabled}
        name="state_location"
        onChange={onChange}
      >
        <option disabled selected>Selecione o Estado</option>
        {data.map((estado, idx) => (
          <option
            key={`${estado.uf}-${idx}`}
            selected={props.selected === estado.id}
            value={estado.id}
          >
            {estado.state_name}
          </option>
        ))}
      </select>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/_components/Address/StateLocation/index.jsx